<template>
  <div class="containerFull_nationalGames">
    <CompreSportsMeetCommon
      :bigSportsList="bigSportsList"
      :containerFullClassName="containerFullClassName"
      :defaultPath="defaultPath"
      :axiosBaseUrl="axiosBaseUrl"
      :sportCompetitionType="sportCompetitionType"
      :themeSeasonArr="themeSeasonArr"
    ></CompreSportsMeetCommon>
  </div>
</template>

<script>
// 全运会 容器
import CompreSportsMeetCommon from './compreSportsMeet_common'
import containerFull_data from '@mixins/compreSportsMeet/NSG/containerFull_data'
export default {
  name: 'containerFull_nationalGames',
  mixins: [containerFull_data],
  components: {
    CompreSportsMeetCommon,
  },
}
</script>
